import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { fetchNews, fetchTrending } from "@/lib/api";
import { NewsCard } from "@/components/NewsCard";
import MostRead from "@/components/MostRead";
import { useLang, categoryName } from "@/i18n";
import { Loader2 } from "lucide-react";

const EMOJI = {
  gundem: "🔥", ekonomi: "📈", spor: "⚽", teknoloji: "💻", dunya: "🌍", saglik: "🏥",
};

export default function Category() {
  const { slug } = useParams();
  const { lang, t } = useLang();
  const [items, setItems] = useState([]);
  const [trending, setTrending] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    (async () => {
      try {
        const [news, trend] = await Promise.all([
          fetchNews({ lang, category: slug, limit: 30 }),
          fetchTrending({ lang, limit: 5 }),
        ]);
        if (cancelled) return;
        setItems(news);
        setTrending(trend);
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => { cancelled = true; };
  }, [slug, lang]);

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10" data-testid="category-page">
      <div className="flex items-end gap-4 border-b-2 border-white pb-3 mb-10">
        <span className="text-4xl" aria-hidden>{EMOJI[slug] || "📰"}</span>
        <h1 className="headline text-4xl sm:text-5xl lg:text-6xl tracking-tight text-white" data-testid="category-title">
          {categoryName(slug, lang)}
        </h1>
        <span className="ml-auto text-xs font-mono uppercase tracking-wider text-neutral-500">
          {items.length} {lang === "tr" ? "haber" : "stories"}
        </span>
      </div>

      {loading ? (
        <div className="py-24 flex items-center justify-center">
          <Loader2 className="animate-spin text-red-600" size={32} />
        </div>
      ) : (
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
          <div className="lg:col-span-8 grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-10">
            {items.map((item) => (
              <NewsCard key={item.id} item={item} />
            ))}
          </div>
          <div className="lg:col-span-4">
            <MostRead items={trending} />
          </div>
        </div>
      )}
    </div>
  );
}
